export default __webpack_public_path__ + "static/media/forgot_pass.6640a954.png";